import { IDeltaBufferEstimatorConfig } from '@abrController/Estimators/DeltaBufferEstimator/DeltaBufferEstimaotr.config';
import { IEstimator } from '@abrController/Estimators/IEstimator';
import { IBufferMetrics } from '@bufferController/BufferMetrics/IBufferMetrics';
import { ConfigConsumer } from '@configProvider/ConfigConsumer';
import { EDebuggableModuleState, TDebuggableAdditionalInfo } from '@customTypes/common';
import { TEventBus } from '@eventBus/EventBus';
import { IResolution } from '@resolutionsManager/IResolutionsManager';
import { BasePlaylistRotationControllerEvents } from '@streamLoader/BasePlaylistRotationController/BasePlaylistRotationController.events';
import bind from '@utils/decorators/bind';

export class DeltaBufferEstimator extends ConfigConsumer<IDeltaBufferEstimatorConfig> implements IEstimator {
  public status: string = 'Idle';
  public state: EDebuggableModuleState = EDebuggableModuleState.OK;
  public additionalInfo: TDebuggableAdditionalInfo = {};
  public groups: string[] = ['abr'];

  private _numberOfFalls: number = 0;
  private _lastKnownBufferAmount: number = 0;
  private _currentBufferAmount: number = 0;
  private readonly _onPlaylistParsedListener: string;

  constructor(eventBus: TEventBus) {
    super('deltaBufferEstimator', eventBus);

    this._onPlaylistParsedListener = this._eventBus.subscribe(
      BasePlaylistRotationControllerEvents.playlists.playlistInfo,
      this._onPlaylistParsed,
    );
  }

  destroy(): void {
    super.destroy();

    this._eventBus.unsubscribe(this._onPlaylistParsedListener);

    this.reset();
  }

  reset(): void {
    this._numberOfFalls = 0;
  }

  getNextEstimatedResolution(
    availableDecreasingResolutions: IResolution[],
    currentResolution: IResolution | null,
    metrics: IBufferMetrics,
  ): IResolution | null {
    this._currentBufferAmount = metrics.bufferAmount;

    return !currentResolution || this._numberOfFalls < this.config.numberOfFallsToDetect
      ? null
      : availableDecreasingResolutions[
          Math.max(0, availableDecreasingResolutions.findIndex(({ name }) => name === currentResolution.name) - 1)
        ];
  }

  public _handleConfigUpdated(): void {
    this._numberOfFalls = 0;
  }

  @bind
  private _onPlaylistParsed(): void {
    const { _currentBufferAmount, _lastKnownBufferAmount } = this;
    this._lastKnownBufferAmount = _currentBufferAmount;

    if (_currentBufferAmount > _lastKnownBufferAmount) {
      this._numberOfFalls = 0;
    }

    const bufferDelta: number = _lastKnownBufferAmount / _currentBufferAmount;

    if (bufferDelta > 1 + this.config.bufferDeltaFractionToDetectFall) {
      this._numberOfFalls++;
    }

    this.additionalInfo = {
      numberOfFalls: this._numberOfFalls,
      bufferDelta,
    };
  }
}
